module.exports = __webpack_public_path__ + "static/media/벤처기업.f88d6a0b.png";